import { sampleSource } from './sampleSource';
type Copy = { zh: string; en: string };
export const sampleText = (value: Copy, locale: string) => locale === 'en' ? value.en : value.zh;
const copy = (zh: string, en: string): Copy => ({ zh, en });

export const sampleSessions = [
  { number: 1, title: copy('从不敢开口开始', 'Finding a starting point') },
  { number: 2, title: copy('区分事实与解释', 'Facts and interpretations') },
  { number: 3, title: copy('给开口一个支点', 'A little support for speaking') },
  { number: 4, title: copy('练习清晰地表达', 'Practicing clear expression') },
  { number: 5, title: copy('看见自己的价值', 'Making room for self-worth') },
  { number: 6, title: copy('把信念带进行动', 'Turning belief into action') },
  { number: 7, title: copy('让对话继续下去', 'Keeping a conversation going') },
  { number: 8, title: copy('把练习带进相遇', 'Bringing practice into life') },
];

// The home hero remains a compact editorial preview; the sample reader contains
// every original message, including source inconsistencies and repetitions.
export const previewMessages = [

      { role: 'assistant', kind: 'quote', text: copy('你已经把「我有值得被喜欢的地方」落到了一个具体场景里，这很实在。回到那一刻，你最先执行、最让你稳下来的是哪一个步骤？', 'You’ve brought “There are things about me worth liking” into a specific situation. That’s something tangible. In that moment, what was the first step that helped you feel steadier?') },
      { role: 'user', kind: 'quote', text: copy('其实那一刻最稳的，应该是我先做的那两轮深呼吸吧。', 'I think what steadied me most was taking those two rounds of deep breaths first.') },
      { role: 'assistant', kind: 'quote', text: copy('如果把刚才的做法浓缩成一个简短的组合，你会怎么命名它？', 'If you gave that little sequence a short name, what would you call it?') },
      { role: 'user', kind: 'quote', text: copy('先深呼吸，再看我的那张小卡片，然后才敢开口。', 'Breathe first, then look at my little card, and then find the courage to speak.') },
    ];

export const previewMemory = {
  session_3: { practice: '两轮呼吸 → 看应付卡 → 轻量开口' },
  session_5: { reminder: '我的价值不由他人当下回应决定。' },
};

export function sessionMemory(number: number) {
  return sampleSource.memoryBefore.sessions.find(item => item.session_number === number)!;
}
